(function () {
    var directivesModule = angular.module('customeDirectivesModule');

    directivesModule.directive('npFeedbackButton', function () {
        return {
            restrict: 'E',
            replace: true,
            controller: ['$scope', '$http', '$uibModal', controller],
            templateUrl: paths.FeedbackButtonView,
            scope: {
                entityId: '='
            },
        };
    });

    function controller($scope, $http, $uibModal) {
        $scope.globalResources = globalResources;
        if ($scope.globalResources.Feedbacktooltip.indexOf('\n(CTRL + ALT + T)') <= 0) {
            $scope.globalResources.Feedbacktooltip = $scope.globalResources.Feedbacktooltip + '\n(CTRL + ALT + T)';
        }

        $scope.popupModal = function () {
            var modalInstance = $uibModal.open({
                templateUrl: paths.FeedbackModalView,
                controller: controllers.feedbackController,
                size: 'lg',
                backdrop: 'static',
                resolve: {
                    model: function () {
						return {
							entityId: $scope.entityId,
							positive: null
						};
                    }
                }
            });
        };

        $scope.$on(broadcastType.toggleDocumentFeedbackTarget, function (e, target) {
            $scope.popupModal();
        });
    }

})();